export default "__VITE_PUBLIC_ASSET__58c3f140__"